"use client";

import AirbnbProjectCard from "@/components/airbnb-project-card";
import { projects } from "@/features/profile/data/projects";

export default function ProjectsGrid() {
  return (
    <div className="mx-auto w-full max-w-7xl px-4">
      <div className="mb-10">
        <p className="mb-2 font-medium text-purple-600 dark:text-purple-400">
          Featured
        </p>
        <h2 className="text-3xl font-bold dark:text-white">Projects</h2>
      </div>

      <div className="grid grid-cols-1 justify-items-center gap-8 py-4 md:grid-cols-2">
        {projects.map((project) => (
          <AirbnbProjectCard key={project.slug} project={project} />
        ))}
      </div>
    </div>
  );
}
